module.exports = __webpack_public_path__ + "img/trophy.6bb4381c.svg";